import React from "react";
import { Gem, PhoneCall, TrendingUp } from "lucide-react";

const CARDS = [
  {
    icon: Gem,
    title: "Every Detail Counts",
    body: [
      "The smallest details often make the biggest difference.",
      "At New Space, we focus on what actually delivers results: accurate pricing, exceptional presentation, targeted marketing, quality viewings and consistent follow-up. Every property is treated as if it were our own, so nothing is overlooked.",
    ],
  },
  {
    icon: PhoneCall,
    title: "Always Within Reach",
    body: [
      "Property management should never leave you chasing updates.",
      "We keep communication clear, honest and proactive, giving you one experienced point of contact who knows your property inside out. Whether it\u2019s a single flat or a growing portfolio, you\u2019ll always know exactly where things stand.",
    ],
  },
  {
    icon: TrendingUp,
    title: "Built Around Results",
    body: [
      "Everything we do is measured by the outcome we achieve for our clients.",
      "We combine local expertise with hands-on management to secure the right tenants, minimise void periods, keep arrears to a minimum and protect the long-term value of your investment. From our roots in Hackney to properties managed across London and the M25 through our partnership with HAUS Block Management, we\u2019re focused on delivering results that last.",
    ],
  },
];

function Badge({ icon: Icon }) {
  return (
    <span className="absolute -bottom-3 right-6 grid h-20 w-20 place-items-center rounded-full bg-[#0e2530] ring-8 ring-[#e8e5dd]">
      <Icon size={30} strokeWidth={1.8} className="text-[#d8b074]" />
    </span>
  );
}

export default function WhatToExpect() {
  return (
    <section className="bg-[#e8e5dd] py-16 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-5">
        <h2 className="text-center font-display text-4xl font-600 text-[#1c1c20] lg:text-5xl">
          What You Can Expect
        </h2>
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((c) => (
            <div
              key={c.title}
              className="relative rounded-3xl bg-[#16323f] p-8 pb-16 shadow-lg transition-transform duration-300 hover:-translate-y-1.5"
            >
              <h3 className="font-display text-2xl font-500 text-[#d8b074]">{c.title}</h3>
              <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-gray-300">
                {c.body.map((p, i) => (
                  <p key={i} className={i === 0 ? "font-medium text-gray-100" : ""}>{p}</p>
                ))}
              </div>
              <Badge icon={c.icon} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
